module.exports = __webpack_public_path__ + "img/fsxq.bdafbec7.png";